exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contact-form[data-v-6b2d656d]{width:60%;margin:2rem auto}@media only screen and (max-width:480px){.contact-form[data-v-6b2d656d]{width:100%}}input[type=email][data-v-6b2d656d],input[type=text][data-v-6b2d656d],select[data-v-6b2d656d],textarea[data-v-6b2d656d]{width:100%;padding:7px;border-radius:3px;border:1px solid #ccc}textarea[data-v-6b2d656d]{height:100px}input[type=checkbox][data-v-6b2d656d]{margin:10px 5px 10px 0}[data-v-6b2d656d]:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-6b2d656d","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Contact.vue
// module id = 46
// module chunks = 0